/* eslint-disable eqeqeq */
import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Popover,
  Radio,
  Select,
  Table,
} from "antd";
import React, { useState } from "react";
import { connect } from "react-redux";
import * as XLSX from "xlsx/xlsx.mjs";
import GenericTaskHistory from "../components/TaskHistory";
import { Capitalize, ConvertDateTime } from "../helper";
import { GetGenericTaskRoleAuthorizationList } from "../services/NeedListService";
import {
  CreateGenericTask,
  DeleteGenericTask,
  DivideGenericTask,
  GetActiveGenericTasks,
  GetFinishedGenericTasks,
  ModifyGenericTask,
  UpdateGenericTask,
} from "../services/ProductionPlanService";
import { CreateQuoteRequest } from "../services/QuoteService";

const config = JSON.parse(localStorage.getItem("config") ?? "{}");
const moment = require("moment/min/moment-with-locales");
moment.locale("tr");

const sortTasksById = (tasks = []) =>
  Array.isArray(tasks)
    ? [...tasks].sort((a, b) => Number(b.id) - Number(a.id))
    : [];

const DivideContent = (Props) => {
  const [amount, setAmount] = useState(1);

  return (
    <div>
      <InputNumber
        max={Props.maxAmount}
        style={{ width: "70%" }}
        size="large"
        defaultValue={1}
        formatter={(value) => `Bölünen Miktar ${value}`}
        parser={(value) => value.split("Bölünen Miktar ")[1]}
        onChange={(value) => setAmount(value)}
      />
      <Button
        danger
        size="large"
        style={{ marginLeft: 10 }}
        onClick={() => {
          DivideGenericTask(Props.id, amount).then((res) => {
            if (res) Props.getTasks();
          });
        }}
      >
        Böl
      </Button>
    </div>
  );
};

class GenericTasksScreen extends React.Component {
  configFile = JSON.parse(localStorage.getItem("config") ?? "{}");

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{
            width: 188,
            marginBottom: 8,
            display: "block",
          }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Bul
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Sıfırla
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        ?.toLowerCase()
        ?.includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => text,
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  state = {
    selectedType: "normal",
    selectedRole: "anasiparis",
    selectedUnit: "adet",
    authorizationList: [],
    // Quote modal state
    quoteModalVisible: false,
    selectedTaskForQuote: null,
    selectedTargets: [],
    quoteRequestLoading: false,
    csvdata: [
      [
        "Görev No",
        "Grup",
        "Başlık",
        "Ek Açıklama",
        "Miktar",
        "Kazan Tipi",
        "Tamamlanan",
        "Görev Verilme Tarihi",
        "Son İşlem Tarihi",
      ],
    ],
    loading: false,
    data: [],
  };

  componentDidMount() {
    this.GetTasks();
    GetGenericTaskRoleAuthorizationList(this.props.user.role).then((res) => {
      if (res) {
        this.setState({ authorizationList: res });
      }
    });
  }

  componentWillReceiveProps = (newProps, oldProps) => {
    setTimeout(() => {
      this.GetTasks();
      GetGenericTaskRoleAuthorizationList(this.props.user.role).then((res) => {
        if (res) {
          this.setState({ authorizationList: res });
        }
      });
    }, 500);
  };

  GetTasks() {
    let isActive = this.props.isActive;

    this.setState({ loading: true });
    let csvdata = [
      [
        "Görev No",
        "Grup",
        "Başlık",
        "Ek Açıklama",
        "Miktar",
        "Tamamlanan",
        "Görev Verilme Tarihi",
        "Son İşlem Tarihi",
      ],
    ];

    if (isActive) {
      GetActiveGenericTasks().then((data) => {
        const sortedData = sortTasksById(data);
        sortedData?.forEach((task) => {
          csvdata.push([
            task.id,
            task.last_location,
            task.title,
            task.description,
            task.amount,
            task.completed_amount,
            ConvertDateTime(task.row_created_date),
            ConvertDateTime(task.row_updated_date),
          ]);
        });
        this.setState({ data: sortedData, csvdata, loading: false });
      });
    } else {
      GetFinishedGenericTasks().then((data) => {
        const sortedData = sortTasksById(data);
        sortedData?.forEach((task) => {
          csvdata.push([
            task.id,
            task.last_location,
            task.title,
            task.description,
            task.amount,
            task.completed_amount,
            ConvertDateTime(task.row_created_date),
            ConvertDateTime(task.row_updated_date),
          ]);
        });
        this.setState({ data: sortedData, csvdata, loading: false });
      });
    }
  }
  SaveExcel = (data) => {
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "DataSheet.xlsx");
  };

  // Quote modal methods
  showQuoteModal = (task) => {
    this.setState({
      quoteModalVisible: true,
      selectedTaskForQuote: task,
      selectedTargets: [],
    });
  };

  hideQuoteModal = () => {
    this.setState({
      quoteModalVisible: false,
      selectedTaskForQuote: null,
      selectedTargets: [],
    });
  };

  createQuoteRequest = () => {
    const { selectedTaskForQuote, selectedTargets } = this.state;

    if (!selectedTargets || selectedTargets.length === 0) {
      Modal.error({
        title: "Hata",
        content: "Lütfen en az bir hedef rol seçin.",
        okText: "Tamam",
      });
      return;
    }

    this.setState({ quoteRequestLoading: true });

    const amount = selectedTaskForQuote.amount.split(" ")[0];
    const unit = selectedTaskForQuote.amount.split(" ")[1] || "adet";

    CreateQuoteRequest({
      targets: selectedTargets,
      productName: selectedTaskForQuote.title,
      description: selectedTaskForQuote.description || "",
      quantity: parseInt(amount),
      unit: unit,
      status: "pending",
      createdBy: this.props.user.username,
      genericTaskId: selectedTaskForQuote.id,
    }).then((res) => {
      this.setState({ quoteRequestLoading: false });
      if (res) {
        this.hideQuoteModal();
      }
    });
  };

  searchInput;

  render() {
    const state = this.state;

    const columns = [
      {
        title: "Görev No",
        dataIndex: "id",
        defaultSortOrder: "descend",
        sorter: (a, b) => a.id - b.id,
        ...this.getColumnSearchProps("id"),
      },
      {
        title: "Grup",
        dataIndex: "last_location",
        sorter: (a, b) => a.last_location.localeCompare(b.last_location),
        ...this.getColumnSearchProps("last_location"),
        render: (text, data) => (
          <td>
            {this.props.isActive ? (
              <Select
                value={config.role?.find((role) => role.type === text)?.text}
                size="large"
                style={{ width: 200 }}
                onChange={(value) => {
                  ModifyGenericTask({ id: data.id, new_group: value }).then(
                    (res) => {
                      this.GetTasks();
                    }
                  );
                }}
              >
                {this.state.authorizationList?.map((permission) => {
                  return (
                    <Select.Option value={permission.authority}>
                      {
                        config.role?.find(
                          (role) => role.type === permission.authority
                        )?.text
                      }
                    </Select.Option>
                  );
                })}
              </Select>
            ) : (
              config.role?.find((role) => {
                if (role.type == text) return true;
                return false;
              })?.text
            )}
          </td>
        ),
      },
      {
        title: "Başlık",
        dataIndex: "title",
        sorter: (a, b) => a.title.localeCompare(b.title),
        ...this.getColumnSearchProps("title"),
        render: (text) => <td>{Capitalize(text)}</td>,
      },
      {
        title: "Ek Açıklama",
        dataIndex: "description",
        sorter: (a, b) => a.description.localeCompare(b.description),
        ...this.getColumnSearchProps("description"),
        render: (text) => <td>{text ? Capitalize(text) : ""}</td>,
      },
      {
        title: "Miktar",
        dataIndex: "amount",
        sorter: (a, b) =>
          parseInt(a.amount.split(" ")[0]) - parseInt(b.amount.split(" ")[0]),
      },
      {
        title: "Tamamlanan",
        dataIndex: "completed_amount",
        sorter: (a, b) => a.completed_amount - b.completed_amount,
      },
      {
        title: "Görev Verilme Tarihi",
        dataIndex: "row_created_date",
        sorter: (a, b) =>
          moment(a.row_created_date).unix() - moment(b.row_created_date).unix(),
        ...this.getColumnSearchProps("row_created_date"),
        render: (text) => <td>{ConvertDateTime(text)}</td>,
      },
      {
        title: "Son İşlem Tarihi",
        dataIndex: "row_updated_date",
        sorter: (a, b) =>
          moment(a.row_updated_date).unix() - moment(b.row_updated_date).unix(),
        ...this.getColumnSearchProps("row_updated_date"),
        render: (text) => <td>{ConvertDateTime(text)}</td>,
      },

      {
        title: "İşlemler",
        render: (text, order) => (
          <td>
            {this.props.user.role == "admin" && (
              <Button
                style={{ margin: 5 }}
                block
                size="large"
                type="default"
                onClick={() => {
                  this.setState({
                    quoteModalVisible: true,
                    selectedTaskForQuote: order,
                    selectedTargets: [],
                  });
                }}
              >
                Teklif İste
              </Button>
            )}

            {this.props.user.role == "admin" ||
            this.props.user.role == "depo" ||
            (this.props.user.role == "ambar1" &&
              order.last_location == "ambar1" &&
              order.title == "QR Kod Basımı") ? (
              <Popconfirm
                title={
                  <div>
                    Bu görevi tamamlamak istediğinizden eminmisiniz? <br /> Bu
                    işlem geri alınamaz
                  </div>
                }
                onConfirm={() => {
                  UpdateGenericTask(order.id, order.amount.split(" ")[0]).then(
                    (res) => {
                      if (res) this.GetTasks();
                    }
                  );
                }}
                okText="Evet"
                cancelText="Hayır"
              >
                <Button style={{ margin: 5 }} block size="large" type="primary">
                  Tamamla
                </Button>
              </Popconfirm>
            ) : null}
            {this.props.user.role == "admin" ||
            this.props.user.role == "depo" ? (
              <Popconfirm
                title={
                  <div>
                    Bu görevi silmek istediğinizden eminmisiniz? <br /> Bu işlem
                    geri alınamaz
                  </div>
                }
                onConfirm={() => {
                  DeleteGenericTask(order.id).then((res) => {
                    if (res) this.GetTasks();
                  });
                }}
                okText="Evet"
                cancelText="Hayir"
              >
                <Button
                  style={{ margin: 5 }}
                  block
                  danger
                  size="large"
                  type="primary"
                >
                  Sil
                </Button>
              </Popconfirm>
            ) : null}
            <Button
              block
              style={{ margin: 5 }}
              onClick={() => {
                this.setState({
                  isModalVisible: true,
                  selectedTaskId: order.id,
                });
              }}
              size="large"
              type="primary"
            >
              İşlem Geçmişi
            </Button>
            {this.props.user.role !== "depo" ||
            (this.props.user.role == "depo" &&
              order.completed_amount == 0 &&
              this.props.isActive) ? (
              <Popover
                content={
                  <DivideContent
                    maxAmount={parseInt(order.amount.split(" ")[0]) - 1}
                    id={order.id}
                    getTasks={this.GetTasks.bind(this)}
                  />
                }
                title={
                  <>
                    Görevin tamamlanan ve kalan kısmını ayırmak istediğinizden
                    emin misiniz? <br /> Bu işlem geri alınamaz
                  </>
                }
                trigger="click"
              >
                <Button
                  style={{ margin: 5 }}
                  block
                  danger
                  size="large"
                  type="primary"
                >
                  Böl
                </Button>
              </Popover>
            ) : null}
          </td>
        ),
      },
    ];

    return (
      <>
        <div>
          <Card>
            {(this.props.user.role === "admin" ||
              this.props.user.role === "depo") && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  marginBottom: 5,
                }}
              >
                <Radio.Group
                  style={{ width: "450px" }}
                  onChange={(e) => {
                    this.setState({ selectedType: e.target.value });
                  }}
                  value={this.state.selectedType}
                >
                  <Radio.Button value="qr">QR Basım</Radio.Button>
                  <Radio.Button value="normal">Normal</Radio.Button>
                </Radio.Group>
                <Input
                  disabled={!this.props.isActive}
                  onChange={(e) => {
                    this.setState({ selectedTitle: e.target.value });
                  }}
                  value={this.state.selectedTitle}
                  style={{ width: 500 }}
                  addonBefore="Görev"
                  placeholder="Görev Tanımı"
                />
                <Input
                  disabled={!this.props.isActive}
                  onChange={(e) => {
                    this.setState({ selectedDescription: e.target.value });
                  }}
                  value={this.state.selectedDescription}
                  style={{ width: 500, marginLeft: 25, marginRight: 25 }}
                  addonBefore="Açıklama?"
                  placeholder="Opsiyonel"
                />
                <Input.Group compact>
                  <InputNumber
                    disabled={!this.props.isActive}
                    onChange={(e) => {
                      this.setState({ selectedAmount: e });
                    }}
                    value={this.state.selectedAmount}
                    style={{ width: 100 }}
                    min={1}
                    placeholder="0"
                  />
                  <Input
                    disabled={!this.props.isActive}
                    onChange={(e) => {
                      this.setState({ selectedUnit: e.target.value });
                    }}
                    value={this.state.selectedUnit}
                    style={{ width: 100 }}
                    defaultValue="adet"
                  />
                </Input.Group>
                <Button
                  style={styles.button}
                  type="primary"
                  loading={this.state.addTaskButtonLoading}
                  disabled={
                    !state.selectedAmount ||
                    !state.selectedTitle ||
                    !state.selectedRole
                  }
                  onClick={() => {
                    this.setState({ addTaskButtonLoading: true });
                    CreateGenericTask({
                      title: state.selectedTitle,
                      description: state.selectedDescription,
                      group:
                        this.props.user.role == "depo"
                          ? "depo"
                          : state.selectedRole,
                      amount: state.selectedAmount,
                      unit: state.selectedUnit,
                    }).then((res) => {
                      if (res) {
                        this.setState({
                          selectedTitle: null,
                          selectedDescription: null,
                          selectedAmount: null,
                          selectedUnit: "adet",
                        });
                        this.GetTasks();
                      }
                      this.setState({ addTaskButtonLoading: false });
                    });
                  }}
                >
                  Emir Oluştur
                </Button>
              </div>
            )}
            <Button
              style={{ ...styles.button, float: "right" }}
              onClick={() => this.SaveExcel(this.state.csvdata)}
            >
              Emirleri Excele Aktar
            </Button>
          </Card>
        </div>

        <Table
          pagination={{ defaultPageSize: 10, position: ["bottomRight"] }}
          rowKey={(row) => "key" + row.id}
          size="small"
          style={{ maxWidth: "99.5%" }}
          loading={this.state.loading}
          columns={columns}
          dataSource={
            this.state.selectedType === "qr"
              ? state.data.filter((task) => task.title === "QR Kod Basımı")
              : state.data.filter((task) => task.title !== "QR Kod Basımı")
          }
        />
        <GenericTaskHistory
          isVisible={this.state.isModalVisible}
          task_id={this.state.selectedTaskId}
          setIsVisible={(value) => this.setState({ isModalVisible: value })}
        />

        {/* Quote Request Modal */}
        <Modal
          title={`Teklif Talebi Oluştur - ${
            state.selectedTaskForQuote?.title || ""
          }`}
          open={state.quoteModalVisible}
          onCancel={this.hideQuoteModal}
          footer={[
            <Button key="cancel" onClick={this.hideQuoteModal}>
              İptal
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={this.state.quoteRequestLoading}
              disabled={
                !state.selectedTargets || state.selectedTargets.length === 0
              }
              onClick={this.createQuoteRequest}
            >
              Teklif Talebi Oluştur
            </Button>,
          ]}
          width={600}
        >
          {state.selectedTaskForQuote && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h4>Görev Bilgileri:</h4>
                <p>
                  <strong>Başlık:</strong> {state.selectedTaskForQuote.title}
                </p>
                <p>
                  <strong>Açıklama:</strong>{" "}
                  {state.selectedTaskForQuote.description || "Açıklama yok"}
                </p>
                <p>
                  <strong>Miktar:</strong> {state.selectedTaskForQuote.amount}
                </p>
              </div>

              <div style={{ marginBottom: 16 }}>
                <h4>Hedef Roller Seçin:</h4>
                <Select
                  mode="multiple"
                  size="large"
                  onChange={(value) => {
                    this.setState({ selectedTargets: value });
                  }}
                  value={state.selectedTargets}
                  style={{ width: "100%" }}
                  placeholder="Hedef Roller Seçin"
                  allowClear
                >
                  {config.role?.map((role) => (
                    <Select.Option key={role.type} value={role.type}>
                      {role.text}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          )}
        </Modal>
      </>
    );
  }
}

const styles = {
  button: {
    marginLeft: 25,
  },
};

const mapStateToProps = (state, ownProps) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(GenericTasksScreen);
